import React, { Component } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


import Tour1 from '../../assets/images/tour1.jfif';
// import Tour2 from '../../assets/images/tour2.jfif';
// import Tour3 from '../../assets/images/tour2.jpg';
// import Tour4 from '../../assets/images/tour3.jfif';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/tour/';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

export default class TourDetailsPage extends Component {
    constructor() {
        super()

        this.data = {
            highlights:'City tour in Singapore with flyer|Afternoon Sentosa Island|Gardens by the bay (flower dome + cloud forest)|City tour in Singapore with flyer'
        }
    }

    AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }

    componentDidMount = ()=>{
       // alert('jjj')
        console.log(this.data.highlights)

   //     var str = this.data.highlights;


    }

    render() {
        return (
            <div className='tour-details-main'>
                <div className='container-fluid'>
                {
                    this.props.mystate.tour_name !== '' ?
                
                    <div className='row'>
                        <div className='col-12'>
                            <div className='tour-details-head'>
                                <h2>{this.AddSpecialChar(this.props.mystate.tour_name)}</h2>
                            </div>
                        </div>
                        <div className='col-12 col-lg-7'>
                            <div className='tour-details-head-content'>
                                <div className='tour-theme'>
                                    <p>{this.props.mystate.tour_theme}</p>
                                </div>
                                <div className='tour-duration-desktop'>
                                <p>{this.AddSpecialChar(this.props.mystate.tour_duration)}</p>
                                </div>
                                <a href={img_path+this.props.mystate.tour_details.replace(',',' ')}
                                target="_blank"
                                 download
                                >
                                <button type='button' className='btn'>
                                
                                Download Details
                                </button>
                                </a>
                            </div>
                        </div>
                       
                        <div className='col-12'>
                            <div className='tour-details-content'>

                                <div className='row'>
                                    <div className='col-md-7 col-lg-7'>
                                        <div className='tour-details-gallery'>
                                        <div className='tour-duration'>
                                        <p>{this.AddSpecialChar(this.props.mystate.tour_duration)}</p>
                                        </div>
                                            <Carousel
                                                swipeable={true}
                                                draggable={true}
                                                responsive={responsive}
                                                showDots={false}
                                                infinite={true}
                                                arrows={true}
                                                autoPlay={true}
                                                autoPlaySpeed={1000}
                                                keyBoardControl={true}
                                                customTransition="all .5"
                                                transitionDuration={1000}
                                                containerclassName="carousel-container"
                                                // style={{marginLeft:'20px'}}
                                                className="tour-details-crousel"
                                                responsive={responsive}>
                                               
                                               
                                                {this.props.mystate.tour_images.length>0 ?
                                                    this.props.mystate.tour_images.map((items,i)=>
                                                    
                                                    <img src={img_path+items} alt="loading..." />
                                                    )
                                                    : <img src={Tour1} alt='loading...'/>

                                                 }
                                               
                                            </Carousel>

                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='tour-details-card'>
                                            <div className='tour-cost'>
                                                <h6>Cost:</h6>
                                                <div style={{ display: 'flex' }}>
                                                    <i class='fa fa-rupee'></i>
                                                    <p>{this.AddSpecialChar(this.props.mystate.tour_cost)}</p>
                                                </div>
                                            </div>
                                            <div className='tour-seperation-line'>
                                            </div>
                                            <div className='tour-city'>
                                                <h6>Cities:</h6>
                                                <p>{this.AddSpecialChar(this.props.mystate.tour_cities)}</p>
                                            </div>
                                            <div className='tour-seperation-line'>
                                            </div>
                                            <div className='tour-details-theme'>
                                                <h6>Theme:</h6>
                                                <p>{this.props.mystate.tour_theme}</p>

                                            </div>
                                            <div className='tour-seperation-line'>
                                            </div>
                                            <div className='tour-highlights'>
                                                <h6>Package Highlights</h6>
                                                <ul>
                                                {this.props.mystate.tour_highlights.length>0 ?
                                                    this.props.mystate.tour_highlights.map((items,i)=>
                                                    items !== '' ?
                                                    <li>{this.AddSpecialChar(items)}</li>
                                                 :''   )
                                               :  <li></li>}
                                                    
                                                   
                                                   
                                                </ul>
                                            </div>
                                            <div className='details-button'>
                                            <button type='button' className='btn' onClick={()=>this.props.GetMoreDetails()}>Get More Details</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                                                :''}
                </div>

            </div>
        )
    }
}

